import React from 'react';
import { firestore } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const getConsoleRef = () => {
  if (typeof window !== 'undefined' && window.console) {
    return window.console;
  }
  if (typeof global !== 'undefined' && global.console) {
    return global.console;
  }
  return undefined;
};

const logComponentError = (error, info) => {
  const consoleRef = getConsoleRef();
  if (process.env.NODE_ENV !== 'production' && consoleRef?.error) {
    consoleRef.error('Unexpected error in component tree:', error, info);
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    addDoc(collection(firestore, 'errorLogs'), {
      error: error?.toString(),
      info: info?.componentStack,
      createdAt: serverTimestamp(),
    }).catch(() => {});
    logComponentError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <div className="p-4">Something went wrong.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
